// export function readmultifiles(files: File[]) {
//   var array: string[] = [];
//   var reader = new FileReader();
//   files.forEach((file) => {
//     reader.onloadend = function () {
//       array.push(reader.result as string);
//     };
//     reader.readAsBinaryString(file);
//   });
//   //   function readFile(index: number = 0) {
//   //     if (index >= files.length) {
//   //       var file = files[index];
//   //       reader.onload = function (e) {
//   //         // get file content
//   //         var bin = (e.target as FileReader).result;
//   //         // do sth with bin
//   //         readFile(index + 1);
//   //       };
//   //       reader.readAsBinaryString(file);
//   //       array.push(reader.result);
//   //     }
//   //   }
//   return array;
// }

export async function readmultifiles(files: File[]) {
  //   var reader = new FileReader();
  // var array: string[] = [];

  // read file 1
  const file1 = new Promise((resolve) => {
    const reader = new FileReader();
    const file = files[0];
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      // get file content
      const base64String = (reader.result as string)
        .replace("data:", "")
        .replace(/^.+,/, "");

      return resolve(base64String as string);
    };
  });

  // read file 2
  const file2 = new Promise((resolve) => {
    const reader2 = new FileReader();
    const file = files[1];
    // reader2.readAsBinaryString(file);
    reader2.readAsDataURL(file);
    reader2.onload = function (e) {
      // get file content
      const base64String = (reader2.result as string)
        .replace("data:", "")
        .replace(/^.+,/, "");
      return resolve(base64String as string);
    };
  });

  // resolve final promisse when all are resolved
  return Promise.all([file1, file2]).then((values) => {
    return values;
  });
}

export async function readfile(file: File) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      // get file content
      const base64String = (reader.result as string)
        .replace("data:", "")
        .replace(/^.+,/, "");

      return resolve(base64String as string);
    };
  }).then((value) => {
    return value;
  });
}
